import React from 'react';
import DSTextField from '../../../design-system/DSTextField';
import DSCircularProgress from '../../../design-system/DSCircularProgress';
import DSAutocomplete from '../../../design-system/DSAutocomplete';
import useUserDropdown from '../hooks/useUserDropdown';
import { SearchUserOutput } from '../../../api/user';
import DSListItem from '../../../design-system/DSListItem';
import DSBox from '../../../design-system/DSBox';
import { DSTypography } from '../../../design-system/Typography';
import { useTheme } from '@mui/material';

const UserDropdown: React.FC = () => {
  const {
    options,
    handleInputChange,
    handleOptionSelect,
    isLoading,
    spacing,
    dropDownValue,
    searchText,
  } = useUserDropdown();
  const { palette } = useTheme();
  return (
    <DSAutocomplete
      options={options}
      getOptionLabel={(option: SearchUserOutput) => option.name}
      renderOption={(props, option) => (
        <DSListItem {...props} key={option.id || option.name}>
          <DSBox>
            <DSTypography variant="body2">{option.name}</DSTypography>
            {option.email && (
              <DSTypography
                variant="caption"
                sx={{ color: palette.text.secondary }}
              >
                {option.email}
              </DSTypography>
            )}
          </DSBox>
        </DSListItem>
      )}
      filterOptions={(x) => x}
      inputValue={searchText}
      value={dropDownValue}
      onInputChange={(event, value) => {
        handleInputChange(event, value);
      }}
      onChange={handleOptionSelect}
      renderInput={(params) => (
        <DSTextField
          {...params}
          placeholder=""
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <DSCircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          sx={{
            width: spacing(30),
            '.MuiInputBase-root': {
              padding: 0,
            },
          }}
        />
      )}
      sx={{
        minWidth: spacing(18),
        marginLeft: spacing(3),
      }}
    />
  );
};

export default UserDropdown;
